module.exports = __webpack_public_path__ + "static/media/LogoCorreos2019_Azul.baa0a380.svg";